
import { Options, Vue } from "vue-class-component";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faHome, faSpinner } from "@fortawesome/free-solid-svg-icons";

library.add( faHome, faSpinner );

@Options( { components : { FontAwesomeIcon } } )
export default class Loader extends Vue
{
  store = useStore( key );
}
